<script>
  export default {
    computed: {
      logueado() {
        return this.$store.getters.loggedIn;
      }
    },
    methods: {
      togglePerfil(){
        this.perfilDropdown = !this.perfilDropdown
      }
    },
    data() {
      return {
        perfilDropdown: false
      }
    }
  }
</script>

<template>
  <div class="menu">
    <div class="menu-container">
      <router-link to="/rastrear-pedido" class="menu-item"><a class="menu-link">
        <b-icon class="menu-link-icon" icon="geo-alt-fill" aria-hidden="true"></b-icon><span class="menu-link-text">Rastrea tu pedido</span></a>
      </router-link>
      <router-link to="/pre-alerta" class="menu-item"><a class="menu-link">
        <b-icon class="menu-link-icon" icon="bell-fill" aria-hidden="true"></b-icon><span class="menu-link-text">Pre Alertas</span></a>
      </router-link>
      <router-link to="/solicitar-despachos" class="menu-item"><a class="menu-link">
        <b-icon class="menu-link-icon" icon="cash" aria-hidden="true"></b-icon><span class="menu-link-text">Facturación y Entrega de Paquetes</span></a>
      </router-link>
      <router-link to="/historial" class="menu-item"><a class="menu-link">
        <b-icon class="menu-link-icon" icon="file-earmark-text-fill" aria-hidden="true"></b-icon><span class="menu-link-text">Historial</span></a>
      </router-link>
      <router-link to="/mi-perfil" class="menu-item"><a class="menu-link">
        <b-icon class="menu-link-icon" icon="person-circle" aria-hidden="true"></b-icon>
        <span class="menu-link-text">Mi perfil</span></a>
      </router-link>
      <router-link to="/destinatarios" class="menu-item"><a class="menu-link">
        <b-icon class="menu-link-icon" icon="people-fill" aria-hidden="true"></b-icon>
        <span class="menu-link-text">Nombres asociados a mi casillero</span></a>
      </router-link>
      <router-link to="/estado-cuenta" class="menu-item menu-item-center"><a class="menu-link">
        <b-icon class="menu-link-icon" icon="wallet" aria-hidden="true"></b-icon><span class="menu-link-text">Estado de cuenta</span></a>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
  .menu{
    display: flex;
    justify-content: center;
  }
  .menu-container {
    display: grid;
    max-width: 80vw;
    grid-template-columns: repeat(4, minmax(250px, 1fr));
    gap: 15px;
    justify-items: center;
    padding: 20px;
  }
  .menu-item{
    grid-column: span 2;
    width: 100%;
    height: 18mm;
    background-color: #f26e0a;
    border-radius: 5px;
    font-size: x-large;
    padding: 10px 25px;
  }
  .menu-item-center{
    grid-column: 1 / span 2 !important;
    grid-column-start: 2 !important;
  }
  .menu-link{
    position: relative;
    display: grid;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 2;
    color: #ffffff;
    text-decoration: none;
    transition: color 250ms ease-in-out, background-color 250ms ease-in-out;
  }
  .menu-item:hover{
    background-color: #043367;
    text-decoration: none;
    .menu-link-icon{
      color: #ffffff;
    }
    transition: background-color 250ms ease-in-out;
  }
  .menu-link:hover{
    text-decoration: none;
  }
  .menu-link-text{
    position: relative;
    z-index: 1;
  }
  .menu-link-icon{
    color: #ffffff4a;
    position: absolute;
    z-index: 0;
    bottom: 10%;
    right: 0%;
    font-size: 35px;
  }
  .menu-link-main{
    grid-column: span 3;
  }
  .grouped-links{
    position: relative;
  }
  .dropdown{
    position: absolute;
    border-radius: 5px;
    border: 1px solid #f26e0acc;
    padding: 0;
    margin: 0;
    background-color: #043367;
    *{
      text-decoration: none;
      color: #ffffff
    }
    *:hover{
      text-decoration: none;
    }

    li{
      padding: 5px 10px;
      transition: background-color 200ms ease-in-out;
      display: block;
      &:hover{
        background-color: #f26e0a;
        transition: background-color 200ms ease-in-out;
      }
    }
  }
  @media (min-width: 900px) and (max-width: 1200px) {
    .menu-container {
      max-width: 80vw;
      grid-template-columns: repeat(2, minmax(250px, 1fr));
    }
    .menu-item-center[data-v-9bcc0be2] {
      grid-column-start: unset !important;
    }
  }
  @media (max-width: 899px) {
    .menu-container {
      max-width: 80vw;
      grid-template-columns: repeat(2, minmax(120px, 1fr));
    }
    .menu-item-center{
      grid-column-start: 1 !important;
    }
    .menu-link-main{
      grid-column: span 2;
    }
  }
  @media (max-width: 650px){
    .menu-item{
      height: 24mm;
    }
    .menu-item-center{
      grid-column-start: unset;
    }
    .menu-link-main{
      grid-column: 1;
    }
  }
</style>